module.exports = __webpack_public_path__ + "static/media/cim-logo-color.9018381c.png";